import styled from "styled-components";
import { formatDate, formatDateTime, toDate } from "./format";

const Time = styled.time`
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

/**
 * Data "07/10/2026"; com `withTime`, "07/10/2026 às 14:32" no fuso local.
 * Sem hora, texto da API vale pela parte da data (não troca o dia pelo fuso).
 */
export default function DateText({ value, withTime = false, className }) {
  const text = withTime ? formatDateTime(value) : formatDate(value);
  if (text === "—") return <span className={className}>—</span>;
  const d = toDate(value, !withTime);
  const pad = (n) => String(n).padStart(2, "0");
  const iso = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return (
    <Time className={className} dateTime={withTime ? `${iso}T${pad(d.getHours())}:${pad(d.getMinutes())}` : iso}>
      {text}
    </Time>
  );
}
